import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['et'],
    small: ['tickets', 'recevez'],
}

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="Grattez les tickets et recevez votre bonus"
            highlights={[
                { word: 'recevez' },
                { word: 'votre' },
                { word: 'bonus' },
            ]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
